import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

export const fmtCurrency = (v) =>
    v == null ? "—" : v.toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 });

export const fmtPct = (v, digits = 2) => (v == null ? "—" : `${v.toFixed(digits)}%`);

export const fmtMarketCap = (mm) => {
    if (mm == null) return "—";
    if (mm >= 1_000_000) return `$${(mm / 1_000_000).toFixed(2)}T`;
    if (mm >= 1_000) return `$${(mm / 1_000).toFixed(1)}B`;
    return `$${mm.toFixed(0)}M`;
};

export const CATEGORY_META = {
    king:       { label: "King",       years: "50+ yrs",   cls: "bg-amber-50 text-amber-800 border border-amber-200" },
    aristocrat: { label: "Aristocrat", years: "25–49 yrs", cls: "bg-emerald-50 text-emerald-800 border border-emerald-200" },
    contender:  { label: "Contender",  years: "10–24 yrs", cls: "bg-blue-50 text-blue-800 border border-blue-200" },
    challenger: { label: "Challenger", years: "5–9 yrs",   cls: "bg-violet-50 text-violet-800 border border-violet-200" },
};
